export const defaultSubjectTemplate = `Reteyn quiz — Super quick 😄`;
